module.exports = __webpack_public_path__ + "img/platform3.a229e0fe.png";